import React from 'react';

export const useProductTour = (productTourDetails) => {
  const [showTourInitiation, setShowTourInitiation] = React.useState(false);
  const [showTourSkipped, setShowTourSkipped] = React.useState(false);
  const [isTourActive, setIsTourActive] = React.useState(false);

  React.useEffect(() => {
    const tourToStart = localStorage.getItem('start_product_tour');
    const hraCompleted = localStorage.getItem('hra_assessment_completed') === 'true';
    
    if (tourToStart && hraCompleted) {
      localStorage.removeItem('start_product_tour');
      showTourInitiationPopup();
    }
  }, []);

  const startTour = () => {
    setShowTourInitiation(false);
    setIsTourActive(true);
  };

  const skipTour = (reminderDays = 30) => {
    setShowTourInitiation(false);
    setShowTourSkipped(true);
    const reminderDate = new Date();
    reminderDate.setDate(reminderDate.getDate() + reminderDays);
    localStorage.setItem('product_tour_reminder_date', reminderDate.toISOString());
  };

  const completeTour = () => {
    setIsTourActive(false);
    localStorage.setItem('product_tour_completed', 'true');
    localStorage.removeItem('product_tour_reminder_date');
  };

  const closeTourSkippedPopup = () => {
    setShowTourSkipped(false);
  };

  const resetTour = () => {
    localStorage.removeItem('product_tour_completed');
    localStorage.removeItem('product_tour_reminder_date');
    setShowTourInitiation(true);
  };

  const showTourInitiationPopup = () => {
    const manualTrigger = localStorage.getItem('start_product_tour') === 'true';
    
    if (manualTrigger) {
      localStorage.removeItem('start_product_tour');
      setShowTourInitiation(true);
      return;
    }
    
    const backendTourCompleted = productTourDetails?.product_tour_data?.user_dashboard === false;
    
    if (backendTourCompleted) {
      return;
    }

    const isNewUser = productTourDetails?.is_new_user === true;
    const hraCompleted = localStorage.getItem('hra_completed') === 'true';
    
    if (isNewUser) {
      const locationDeptCompleted = localStorage.getItem('location_dept_completed') === 'true';
      if (!locationDeptCompleted || !hraCompleted) {
        return;
      }
    } else {
      if (!hraCompleted) {
        return;
      }
    }
    
    const reminderDate = localStorage.getItem('product_tour_reminder_date');
    if (reminderDate) {
      const now = new Date();
      const reminder = new Date(reminderDate);
      if (now >= reminder) {
        setShowTourInitiation(true);
      }
    } else {
      setShowTourInitiation(true);
    }
  };

  return {
    showTourInitiation,
    showTourSkipped,
    isTourActive,
    startTour,
    skipTour,
    completeTour,
    closeTourSkippedPopup,
    resetTour,
    showTourInitiationPopup
  };
};
